import { configHome, configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import {
  Ads,
  Card,
  CustomClassContext,
  LatestArticle,
  Typography,
} from "@sphtech/dmg-design-system";
import cx from "classnames";
import { Fragment, ReactNode, useContext } from "react";

import styles from "../homelayout.module.css";
import { HomeLayoutProps } from "./utils";

type Props = {
  data: HomeLayoutProps["data"];
};

export default function HomeLatestStory({ data }: Props): ReactNode {
  const customClass = useContext(CustomClassContext);

  return (
    <div className={styles.bodyContainer}>
      <div
        className={cx(
          styles.latestArticleContainer,
          customClass?.homeLatestArticle?.container,
        )}
      >
        <div className={styles.latestArticleLayout}>
          <div
            className={cx(
              styles.latestArticleItemContainer,
              customClass?.homeLatestArticle?.item,
            )}
          >
            {data.latestArticle.items.map((teaser, index) => (
              <Fragment key={index}>
                {configHome.latestArticle.card ? (
                  <Card
                    {...teaser}
                    variant={configHome.latestArticle.card.defaultVariant}
                    mobileUpVariant={
                      configHome.latestArticle.card.mobileUp.defaultVariant
                    }
                    placeholders={placeholders}
                  />
                ) : (
                  <div
                    className={cx(
                      styles.latestArticleItem,
                      configHome.latestArticle.skipImage ||
                        configHome.latestArticle.landscapeIndexes?.includes(
                          index,
                        )
                        ? styles.landscape
                        : styles.portrait,
                    )}
                  >
                    <LatestArticle
                      key={index}
                      {...teaser}
                      skipImage={configHome.latestArticle.skipImage}
                      mode={
                        configHome.latestArticle.skipImage ||
                        configHome.latestArticle.landscapeIndexes?.includes(
                          index,
                        )
                          ? "landscape"
                          : "portrait"
                      }
                      mobileMode={configHome.latestArticle.mobileMode}
                      placeholders={placeholders}
                      displayPublishDate={configTeaser.publishDate}
                      dateAfter={configTeaser.dateAfter}
                    />
                  </div>
                )}
              </Fragment>
            ))}
          </div>

          {!configHome.latestArticle.skipViewMore &&
            data.latestArticle.viewMore && (
              <div className={styles.latestArticleCtaContainer}>
                <Typography.TextLink href={data.latestArticle.viewMore.url}>
                  {configHome.latestArticle.viewMore?.text ||
                    data.latestArticle.viewMore.text}
                  {configHome.viewMore?.icon}
                </Typography.TextLink>
              </div>
            )}
        </div>
        <div className={styles.imuContainer}>
          <Ads.AdsSideBar />
        </div>
      </div>
    </div>
  );
}
